import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomService } from '../../_service/custom.service';

@Component({
    selector: 'app-internship-form',
    templateUrl: './internship-form.component.html',
    styleUrls: ['./internship-form.component.css']
})
export class InternshipFormComponent implements OnInit {

    fileToUpload: File = null;
    joinusForm:FormGroup;
    submitform : boolean = false;

    show_successmsg : boolean = false;
    msg : any;
    show_errormsg : boolean = false;
    upload_filename :any;
    upload_file : boolean = false;

    constructor(
        private fb : FormBuilder,
        public api : CustomService,
    ) { }

    ngOnInit() {

        this.joinusForm = this.fb.group({
            full_name : ['',Validators.required],
            phone : ['',Validators.required],
            email : ['',[Validators.required,Validators.email]],
            phone_second : [''],
            address : ['',Validators.required],
            city : ['',Validators.required],
            zipcode : [''],
            country : [''],
            state : [''],
            incident_type : [''],
            incident_date : [''],
            incident_desc : ['',Validators.required],
            incident_file : [''],
            law_enforcement : [''],
            agree : ['',Validators.required],
            type  : ['internship'],
        });
    }

    get f(){
        return this.joinusForm.controls;
    }

    handleFileInput(files: FileList){
        this.fileToUpload = files.item(0);
        this.api.uploadfile(this.fileToUpload).subscribe(
            (data:any)=>{
                this.upload_filename = data.file_name;
                this.joinusForm.patchValue({incident_file : this.upload_filename});
                this.upload_file = true;
            },(errors:any)=>{
                console.log(errors);
                this.upload_file = false;
                this.show_errormsg = true;
                this.msg = errors.error.message;
            }
        );
    }

    joinus(){
        this.submitform = true;
        if(this.joinusForm.invalid){
            console.log("Invalid");
            return false;
        }else{
            this.api.joinus(this.joinusForm.value).subscribe(
                (data:any)=>{
                    this.show_successmsg = true;
                    this.show_errormsg = false;
                    this.msg = data.msg;
                    this.joinusForm.reset();
                    this.submitform = false;
                },(errors:any)=>{
                    this.show_successmsg = false;
                    this.show_errormsg = true;
                    this.msg = errors.error;
                }
            );
        }
    }

}
